<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">TBA Participations</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">
        Dashboard
      </router-link>
      /

      <b>TBA</b> / <b>Participations</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- New -->
        <div class="card text-left">
          <div class="card-body">
            <h4 class="card-title mb-3">
              New
              <span
                class="badge badge-pill badge-danger"
                v-if="new_purchases.length !== 0"
                >{{ new_purchases.length }}</span
              >
            </h4>
            <p>The table below shows the list of new participations.</p>
            <div class="table-responsive">
              <table
                id="new_purchase_tbl"
                class="display table table-striped table-bordered"
                style="width:100%; text-align: center;"
              >
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Customer Name</th>
                    <th>Product</th>
                    <th>Type</th>
                    <th>Date Participated</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(purchase, index) in new_purchases"
                    v-bind:key="index"
                  >
                    <td>{{ index + 1 }}</td>
                    <td>
                      <router-link :to="customerPage(purchase.customer_id)">
                        {{ purchase.customer_name }}
                      </router-link>
                    </td>
                    <td>
                      <router-link :to="productPage(purchase.product_id)">
                        {{ purchase.product_name }}
                      </router-link>
                    </td>
                    <td>{{ purchase.type }}</td>
                    <td>
                      {{
                        purchase.date_participated
                          | moment("Do MMMM YYYY, h:mm:ss a")
                      }}
                    </td>
                    <td>
                      <button
                        @click="proceedToProcess(purchase.purchase_id)"
                        class="btn btn-success btn-rounded btn-block"
                        style="background-color: #78BE20; border-color: #78BE20;"
                      >
                        Proceed
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <br />

        <!-- In Process -->
        <div class="card text-left">
          <div class="card-body">
            <h4 class="card-title mb-3">In Process</h4>
            <p>The table below shows the list of in process participations.</p>
            <div class="table-responsive">
              <table
                id="inprocess_purchase_tbl"
                class="display table table-striped table-bordered"
                style="width:100%; text-align: center;"
              >
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Customer Name</th>
                    <th>Product</th>
                    <th>Type</th>
                    <th>Date Participated</th>
                    <th>Officer</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(purchase, i) in inprocess_purchases"
                    v-bind:key="i"
                  >
                    <td>{{ i + 1 }}</td>
                    <td>
                      <router-link :to="customerPage(purchase.customer_id)">
                        {{ purchase.customer_name }}
                      </router-link>
                    </td>
                    <td>
                      <router-link :to="productPage(purchase.product_id)">
                        {{ purchase.product_name }}
                      </router-link>
                    </td>
                    <td>{{ purchase.type }}</td>
                    <td>
                      {{
                        purchase.date_participated
                          | moment("Do MMMM YYYY, h:mm:ss a")
                      }}
                    </td>
                    <td>{{ purchase.officer }}</td>
                    <td>
                      <router-link
                        :to="purchaseDetail(purchase.purchase_id)"
                        type="button"
                        class="btn btn-success btn-rounded btn-block"
                        style="background-color: #78BE20; border-color: #78BE20;"
                      >
                        View Details
                      </router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <br />

        <!-- Completed -->
        <div class="card text-left">
          <div class="card-body">
            <h4 class="card-title mb-3">Completed</h4>
            <p>The table below shows the list of completed participations.</p>
            <div class="table-responsive">
              <table
                id="completed_purchase_tbl"
                class="display table table-striped table-bordered"
                style="width:100%; text-align: center;"
              >
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Customer Name</th>
                    <th>Product</th>
                    <th>Type</th>
                    <th>Date Participated</th>
                    <th>Officer</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(purchase, i) in completed_purchases"
                    v-bind:key="i"
                  >
                    <td>{{ i + 1 }}</td>
                    <td>
                      <router-link :to="customerPage(purchase.customer_id)">
                        {{ purchase.customer_name }}
                      </router-link>
                    </td>
                    <td>
                      <router-link :to="productPage(purchase.product_id)">
                        {{ purchase.product_name }}
                      </router-link>
                    </td>
                    <td>{{ purchase.type }}</td>
                    <td>
                      {{
                        purchase.date_participated
                          | moment("Do MMMM YYYY, h:mm:ss a")
                      }}
                    </td>
                    <td>{{ purchase.officer }}</td>
                    <td>
                      <router-link
                        :to="purchaseDetail(purchase.purchase_id)"
                        type="button"
                        class="btn btn-success btn-rounded btn-block"
                        style="background-color: #78BE20; border-color: #78BE20;"
                      >
                        View Details
                      </router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <br />

        <!-- Cancelled -->
        <div class="card text-left">
          <div class="card-body">
            <h4 class="card-title mb-3">Cancelled</h4>
            <p>The table below shows the list of cancelled participations.</p>
            <div class="table-responsive">
              <table
                id="cancelled_purchase_tbl"
                class="display table table-striped table-bordered"
                style="width:100%; text-align: center;"
              >
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Customer Name</th>
                    <th>Product</th>
                    <th>Type</th>
                    <th>Date Participated</th>
                    <th>Date cancelled</th>
                    <th>Cancelled By</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(purchase, i) in cancelled_purchases"
                    v-bind:key="i"
                  >
                    <td>{{ i + 1 }}</td>
                    <td>
                      <router-link :to="customerPage(purchase.customer_id)">
                        {{ purchase.customer_name }}
                      </router-link>
                    </td>
                    <td>
                      <router-link :to="productPage(purchase.product_id)">
                        {{ purchase.product_name }}
                      </router-link>
                    </td>
                    <td>{{ purchase.type }}</td>
                    <td>
                      {{
                        purchase.date_participated
                          | moment("Do MMMM YYYY, h:mm:ss a")
                      }}
                    </td>
                    <td>
                      {{
                        purchase.date_cancelled
                          | moment("Do MMMM YYYY, h:mm:ss a")
                      }}
                    </td>
                    <td>{{ purchase.officer }}</td>
                    <td>
                      <router-link
                        :to="purchaseDetail(purchase.purchase_id)"
                        type="button"
                        class="btn btn-success btn-rounded btn-block"
                        style="background-color: #78BE20; border-color: #78BE20;"
                      >
                        View Details
                      </router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import { setTimeout } from "timers";
import { global } from "@/global";

export default {
  name: "tba_purchase",
  components: {},
  data() {
    return {
      url: global.url,
      new_purchases: [],
      inprocess_purchases: [],
      completed_purchases: [],

      cancelled_purchases: []
    };
  },

  methods: {
    // load all purchases to save axios from keep making multiple queries in one page
    loadAllPurchases() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        // Status "Paid(3)"
        axios
          .get("/tba/purchase/all_purchases", {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            this.new_purchases = res.data.new;
            this.inprocess_purchases = res.data.in_process;
            this.completed_purchases = res.data.completed;
            this.cancelled_purchases = res.data.cancelled;
            this.destroyDatatable();
          })
          .then(function() {
            $("#new_purchase_tbl").DataTable({
              // "deferRender" : true,
              // "ajax" : {
              //     'url': this.url + "/tba/purchase/all_purchases?type=new",
              //     'type': 'GET',
              //     'beforeSend': function (request) {
              //         request.setRequestHeader("Authorization", 'Bearer ' + token);
              //     }
              // },
              pageLength: 5,
              dom: "Bfrtip",
              buttons: ["excel", "pdf"]
            });

            $("#inprocess_purchase_tbl").DataTable({
              // "deferRender" : true,
              // "ajax" : {
              //     'url': this.url + "/tba/purchase/all_purchases?type=in_process",
              //     'type': 'GET',
              //     'beforeSend': function (request) {
              //         request.setRequestHeader("Authorization", 'Bearer ' + token);
              //     }
              // },
              pageLength: 5,
              dom: "Bfrtip",
              buttons: ["excel", "pdf"]
            });

            $("#completed_purchase_tbl").DataTable({
              // "deferRender" : true,
              // "ajax" : {
              //     'url': this.url + "/tba/purchase/all_purchases?type=completed",
              //     'type': 'GET',
              //     'beforeSend': function (request) {
              //         request.setRequestHeader("Authorization", 'Bearer ' + token);
              //     }
              // },
              pageLength: 5,
              dom: "Bfrtip",
              buttons: ["excel", "pdf"]
            });

            $("#cancelled_purchase_tbl").DataTable({
              // "deferRender" : true,
              pageLength: 5,
              dom: "Bfrtip",
              buttons: ["excel", "pdf"]
            });
          });
      }
    },

    purchaseDetail(id) {
      return "/tba/details/" + id;
    },

    destroyDatatable() {
      $("#new_purchase_tbl")
        .DataTable()
        .destroy();
      $("#inprocess_purchase_tbl")
        .DataTable()
        .destroy();
      $("#completed_purchase_tbl")
        .DataTable()
        .destroy();
      $("#cancelled_purchase_tbl")
        .DataTable()
        .destroy();
    },

    loadAllData() {
      this.loadAllPurchases();
    },

    proceedToProcess(id) {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;
        swal({
          icon: "warning",
          text: "Are you sure?",
          buttons: ["Cancel", "Yes"]
        }).then(confirm => {
          if (confirm) {
            axios
              .post(
                "/detail/approve/" + id,
                {
                  _method: "patch"
                },
                {
                  headers: {
                    Authorization: "Bearer " + token
                  }
                }
              )
              .then(res => {
                if (res.data.authorised === false) {
                  swal({
                    icon: "error",
                    text: "Not authorised"
                  });
                } else {
                  if (res.data.success === true) {
                    swal({
                      icon: "success",
                      text: "Successful!"
                    }).then(ok => {
                      this.loadAllData();
                    });
                  } else {
                    swal({
                      icon: "error",
                      text: res.data.message
                    });
                  }
                }
              });
          } else {
            swal({
              icon: "info",
              text: "Cancelled"
            });
          }
        });
      }
    },

    proceedToComplete(id) {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;
        swal({
          icon: "warning",
          text: "Are you sure?",
          buttons: ["Cancel", "Yes"]
        }).then(confirm => {
          if (confirm) {
            axios
              .post(
                "/detail/approve/" + id,
                {
                  _method: "patch"
                },
                {
                  headers: {
                    Authorization: "Bearer " + token
                  }
                }
              )
              .then(res => {});
          } else {
            swal({
              icon: "info",
              text: "Cancelled"
            });
          }
        });
      }
    },

    customerPage(id) {
      return "/customer_details/" + id;
    },

    productPage(id) {
      return "/marketing/product/detail/" + id;
    }
  },

  mounted() {
    this.loadAllPurchases();
  }
};
</script>
